/**
 * Normalize a webpack-imported asset URL into a root-relative path so that
 * server-side and client-side renders emit identical <img src> attributes.
 *
 * Webpack uses an absolute publicPath (e.g. "http://localhost:3001/") in the
 * client bundle and no publicPath on the server bundle, which would otherwise
 * cause a React hydration mismatch on every <img> that imports an asset.
 *
 * @param {string} url - raw asset URL from a webpack `import` statement
 * @returns {string} root-relative URL (always starts with a single slash)
 */
export function resolveAssetUrl(url) {
  if (!url || url.startsWith("data:")) return url;
  const stripped = url.replace(/^https?:\/\/[^/]+/, "");
  return stripped.startsWith("/") ? stripped : `/${stripped}`;
}
